// extracted by mini-css-extract-plugin
export default {"root":"CSSLoadError-root-a2a6379932f4f73890df0f2cdedc1036"};